// Helper to parse JSONB fields with locale
export const getLocalizedValue = (json: any, locale: 'en' | 'fr'): string => {
    let parsedJson = json;
    if (typeof parsedJson === 'string') {
        try {
            parsedJson = JSON.parse(parsedJson);
        } catch (e) {
            // Not a valid JSON string, return empty
            console.error('Failed to parse JSONB string:', json, e);
            return '';
        }
    }

    if (parsedJson && typeof parsedJson === 'object' && parsedJson[locale]) {
        return parsedJson[locale];
    }
    return '';
};
